import React, { useState, useEffect } from "react";
import { auth } from "../firebase";
import "../styles/SubscriptionModal.css";

const SubscriptionModal = ({ isOpen, onClose }) => {
  const [selectedPlan, setSelectedPlan] = useState("1month");
  const [isLemonSqueezyReady, setIsLemonSqueezyReady] = useState(false);

  useEffect(() => {
    // LemonSqueezy 스크립트 로드
    const script = document.createElement("script");
    script.src = "https://assets.lemonsqueezy.com/lemon.js";
    script.defer = true;

    script.onload = () => {
      setIsLemonSqueezyReady(true);
    };

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const plans = {
    "1month": {
      name: "1개월 패키지",
      price: "59,000",
      checkoutUrl:
        "https://toeicmon.lemonsqueezy.com/buy/387fb2d6-ab53-47ee-8ebe-d2817cb6e057",
      features: [,],
    },
  };

  const handleSubscribe = async () => {
    try {
      const user = auth.currentUser;
      if (!user) {
        return;
      }

      const checkoutUrl =
        `${plans[selectedPlan].checkoutUrl}?` +
        `checkout[email]=${encodeURIComponent(user.email)}&` +
        `checkout[custom][firebase_uid]=${encodeURIComponent(user.uid)}&` +
        `t=${Date.now()}`;

      // window.location.href 대신 LemonSqueezy API 사용
      if (window.LemonSqueezy) {
        window.LemonSqueezy.Url.Open(checkoutUrl);
      } else {
        window.location.href = checkoutUrl;
      }
    } catch (error) {
      // 에러 처리
    }
  };

  if (!isOpen) return null;

  return (
    <div className="dashboard-modal-overlay">
      <div className="dashboard-modal-content">
        <div className="dashboard-modal-header">
          <h2>프리미엄 결제</h2>
          <button className="dashboard-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="dashboard-plan-card">
          <div className="dashboard-plan-title">{plans[selectedPlan].name}</div>

          <div className="dashboard-price">₩{plans[selectedPlan].price}</div>

          <ul className="dashboard-features">
            {plans[selectedPlan].features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>

          <button
            className="dashboard-subscribe-button"
            onClick={handleSubscribe}
            disabled={!isLemonSqueezyReady}
          >
            시작하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
